module.exports = __webpack_public_path__ + "img/8_jbt8010_1a-1999.prt.d18d3c15.jpg";